import {
  WORK_REQUEST_ATTACHMENT_MAX_BYTES,
  WORK_REQUEST_ATTACHMENT_MAX_COUNT,
  WORK_REQUEST_ATTACHMENT_TYPES,
} from "../../../queries/useWorkRequestFiles";

/** A file staged on a new request, keyed for rendering and removal. */
export type StagedAttachment = { id: string; file: File };

export type AttachmentSelection = {
  /** Files that pass the limits, in addition to the ones already staged. */
  accepted: File[];
  /** One message per rejected file. */
  errors: string[];
};

function rejectionReason(file: File) {
  if (!(WORK_REQUEST_ATTACHMENT_TYPES as readonly string[]).includes(file.type))
    return `${file.name} was not added. Attach JPEG, PNG, or WebP images.`;
  if (file.size === 0) return `${file.name} was not added. The file is empty.`;
  if (file.size > WORK_REQUEST_ATTACHMENT_MAX_BYTES)
    return `${file.name} was not added. Images can be up to 25 MB.`;
  return null;
}

/**
 * Applies the Work Request attachment limits to newly selected files before
 * they are staged, so a file the API would reject is never queued.
 */
export function selectAttachments(
  stagedCount: number,
  selected: readonly File[],
): AttachmentSelection {
  const accepted: File[] = [];
  const errors: string[] = [];
  for (const file of selected) {
    const reason = rejectionReason(file);
    if (reason) {
      errors.push(reason);
    } else if (
      stagedCount + accepted.length >=
      WORK_REQUEST_ATTACHMENT_MAX_COUNT
    ) {
      errors.push(
        `${file.name} was not added. A request can have up to ${WORK_REQUEST_ATTACHMENT_MAX_COUNT} attachments.`,
      );
    } else {
      accepted.push(file);
    }
  }
  return { accepted, errors };
}
